import  { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ChannelProgramComponent } from '../components/channel-program.component';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectChannelProgramsQueryItems } from '../../../../../../redux/channel-program/selector';
import { channelPrograms } from '../../../../../../redux/channel-program/action';
import PageLoader from '../../../../../../components/PageLoader';



const ShipXChannelProgram = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const accountTypeQuery = useSelector(selectChannelProgramsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedChannelProgram,
    setSelectedChannelProgram
  ] = useState<any>({})


  const fetchChannelProgramById = () => {
    dispatch(channelPrograms.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs/fetch-detail`, entity: 'channelPrograms', jsonData: {
        Context:{},
        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedChannelProgram({ ...selectedChannelProgram, [field]: event });
  }

  useEffect(
    () => {
    
        if (parmas?.id > 0) {
          fetchChannelProgramById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedChannelProgram(accountTypeQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async () => {
    if (parmas?.id > 0) {
      await dispatch(channelPrograms.resetAction({ actionType: 'update' }))
      await dispatch(channelPrograms.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs`, entity: 'accountTypes', jsonData: {

         
              Context:{},
            Records:[{
             
                 
      "Id": selectedChannelProgram?.GlobalChannelShipXProgramId,
      "Name": selectedChannelProgram?.Name,
      "Code": selectedChannelProgram?.Code,
      "Description": selectedChannelProgram?.Description,
       "IsActive":selectedChannelProgram?.IsActive,
      "CreatedOnUtc":selectedChannelProgram?.CreatedOnUtc,
      "ModifiedOnUtc":selectedChannelProgram?.ModifiedOnUtc
    
        }]

        }
      }))

    } else {
      await dispatch(channelPrograms.resetAction({ actionType: 'create' }))
      await dispatch(channelPrograms.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs`, entity: 'accountTypes', jsonData: {

         
              Context:{},
            Records:[{
               Id: selectedChannelProgram?.GlobalChannelProgramId ||0,
              Name: selectedChannelProgram?.Name,
              Description: selectedChannelProgram?.Description,
              Code: selectedChannelProgram?.Code,
              IsActive: selectedChannelProgram?.IsActive
        }]
        }
      }))
    }

    back()
  }

  const back = () => {
    navigate('/dbn/shipx-cloud/channel-management/shipx-channel-programs')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <ChannelProgramComponent
          selectedChannelProgram={selectedChannelProgram}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ShipXChannelProgram;